<template>
  <div class="page">
    <div class="content">
      <router-view />
    </div>
    <nut-tabbar class="bottom_tabbar"
                :tabbar-list="tabList"
                :bottom="true">
    </nut-tabbar>
  </div>
</template>
<script>
export default {
  name: 'sellerLayout',
  components: {},
  data () {
    const that = this
    return {
      tabList: [
        {
          'tabTitle': '首页',
          'curr': that.$route.path === '/sellerCenter/sellerHome',
          'icon': require('@/assets/images/homeone@2x.png'),
          'activeIcon': require('@/assets/images/hometwo@2x.png'),
          'href': '#/sellerCenter/sellerHome'
        },
        {
          'tabTitle': '订单',
          'curr': that.$route.path === '/sellerCenter/sellerOrder',
          'icon': require('@/assets/images/order@2x.png'),
          'activeIcon': require('@/assets/images/ordertwo@2x.png'),
          'href': '#/sellerCenter/sellerOrder'
        },
        {
          'tabTitle': '报表',
          'curr': that.$route.path === '/sellerCenter/report',
          'icon': require('@/assets/images/report@2x.png'),
          'activeIcon': require('@/assets/images/reporttwo@2x.png'),
          'href': '#/sellerCenter/report'
        },
        {
          'tabTitle': '财务',
          'curr': that.$route.path === '/sellerCenter/finance',
          'icon': require('@/assets/images/Finance@2x.png'),
          'activeIcon': require('@/assets/images/Financetwo@2x.png'),
          'href': '#/sellerCenter/finance'
        }
      ]
    }
  },
  methods: {}
}
</script>
<style scoped>
.content {
  margin-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// src/layout/seller.vue